import get from 'lodash-es/get'
import * as React from 'react'

import { Site } from '../../../../common/constants/siteList'
import { getCurrentSiteFromDomain } from '../../../../common/utils/sites'
import AudioPreviewer from '../../../v0/components/itemCard/audioPreviewer'
import DefaultItemPreviewer from '../../../v0/components/itemCard/defaultItemPreviewer'
import MagnifierConfigurator from '../magnifier/configurator'
import Overlay from '../overlay'

import { IItem } from '../../../../typings/searchResults'

import * as styles from './index.module.css'

const ItemPreviewer = ({
  item,
  annotation,
  videoMuted,
  muteVideo,
  onClick,
  nonSquare = false
}: {
  item: IItem
  annotation?: string
  videoMuted: boolean
  muteVideo: () => void
  onClick?: () => void
  nonSquare?: boolean
}) => {
  const itemSite = getCurrentSiteFromDomain(item.site)
  const nonSquareImageUrl = get(item, 'previews.thumbnail_preview.small_url')
  const smallPreviewUrl = nonSquare
    ? nonSquareImageUrl
    : item.ui.smallPreviewUrl

  const itemPreviewer =
    itemSite === Site.audiojungle ? (
      <AudioPreviewer
        imageUrl={item.ui.smallPreviewUrl}
        audioUrl={get(item, 'previews.icon_with_audio_preview.mp3_url')}
        url={item.url}
        isTrending={item.trending}
        name={item.name}
        onClick={onClick}
        rank={0}
      />
    ) : (
      <DefaultItemPreviewer
        url={item.url}
        name={item.name}
        imageUrl={smallPreviewUrl}
        onClick={onClick}
        isSquareImage={!nonSquare}
      />
    )

  const overlayContent = (
    <div className={styles.magnifier}>
      <MagnifierConfigurator
        item={item}
        videoMuted={videoMuted}
        muteVideo={muteVideo}
      />
    </div>
  )

  return (
    <div>
      <Overlay position="side" content={overlayContent}>
        {itemPreviewer}
      </Overlay>
      {annotation && <small className={styles.annotation}>{annotation}</small>}
    </div>
  )
}

export default ItemPreviewer
